export default "__VITE_ASSET__KfXkwTdU__"